import React, { useState } from "react";
import { CardElement, useStripe, useElements } from "@stripe/react-stripe-js";
import { instance } from "../services/instanceApi";

import { loadStripe } from "@stripe/stripe-js";
import { Elements } from "@stripe/react-stripe-js";

const DonationForm = () => {
  const stripe = useStripe();
  const elements = useElements();
  const [amount, setAmount] = useState(10);
  const [error, setError] = useState(null);
  const [success, setSuccess] = useState(false);
  const [processing, setProcessing] = useState(false);

  const handleSubmit = async (event) => {
    event.preventDefault();
    if (!stripe || !elements) {
      return;
    }
    setProcessing(true);

    try {
      const { data } = await instance.post("/donation/create-payment-intent", {
        amount: Number(amount)
      });

      const { clientSecret } = data;

      const cardElement = elements.getElement(CardElement);

      const paymentResult = await stripe.confirmCardPayment(clientSecret, {
        payment_method: {
          card: cardElement
        }
      });

      if (paymentResult.error) {
        setError(paymentResult.error.message);
        setSuccess(false);
        setProcessing(false);
      } else {
        if (paymentResult.paymentIntent.status === "succeeded") {
          setError(null);
          setSuccess(true);
          setProcessing(false);
        }
      }
    } catch (err) {
      setError("An unexpected error occurred.");
      setProcessing(false);
    }
  };

  const cardElementOptions = {
    style: {
      base: {
        color: "#32325d",
        fontFamily: '"Helvetica Neue", Helvetica, sans-serif',
        fontSmoothing: "antialiased",
        fontSize: "16px",
        "::placeholder": {
          color: "#aab7c4"
        }
      },
      invalid: {
        color: "#fa755a",
        iconColor: "#fa755a"
      }
    }
  };

  return (
    <div style={{ maxWidth: "500px", margin: "50px auto", padding: "20px", border: "1px solid #ccc", borderRadius: "10px" }}>
      <h2>Faire un don</h2>
      {!success ? (
        <form onSubmit={handleSubmit}>
          <div style={{ marginBottom: "20px" }}>
            <label>
              Montant (€):
              <input
                type="number"
                value={amount}
                onChange={(e) => setAmount(e.target.value)}
                min="5"
                style={{ width: "100%", padding: "8px", marginTop: "5px" }}
              />
            </label>
          </div>
          <div style={{ marginBottom: "20px" }}>
            <label>
              Carte de crédit
              <CardElement options={cardElementOptions} />
            </label>
          </div>
          <button
            type="submit"
            disabled={!stripe || processing}
            style={{ width: "100%", padding: "10px", background: "#007bff", color: "white", border: "none", borderRadius: "5px", cursor: "pointer" }}>
            {processing ? "Traitement..." : `Payer ${amount}€`}
          </button>
          {error && <div style={{ color: "red", marginTop: "10px" }}>{error}</div>}
        </form>
      ) : (
        <div>
          <h3>Merci pour votre don !</h3>
          <p>Votre soutien est très apprécié.</p>
        </div>
      )}
    </div>
  );
};

const stripePromise = loadStripe(process.env.REACT_APP_STRIPE_PUBLISHABLE_KEY);

const DonationPage = () => {
  return (
    <Elements stripe={stripePromise}>
      <DonationForm />
    </Elements>
  );
};

export default DonationPage;
